import React from 'react';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-4';

type PaginationProps = {
  currentPage: number;
  floating?: boolean;
  totalPages: number;
  onChange: (page: number) => void;
};

export default function Pagination({
  currentPage,
  floating = false,
  totalPages,
  onChange,
}: PaginationProps) {
  const wrapperClasses = floating
    ? 'd-flex justify-content-center py-3 border rounded bg-white shadow'
    : 'd-flex justify-content-center py-3 border-top bg-white';

  return (
    <div className={wrapperClasses}>
      <UltimatePagination
        currentPage={currentPage}
        totalPages={totalPages}
        onChange={onChange}
      />
    </div>
  );
}

